import React from "react";
import PieChart from "./PieChart";
function PieCharts(props) {
  return (
    <div style={{ paddingBottom: "10%" }}>
      <PieChart
        numberCells={2}
        labels={["CP", "NP"]}
        data={props.data}
        language={props.language}
      />
      <PieChart
        numberCells={1}
        labels={["A"]}
        data={props.data}
        language={props.language}
      />
      <PieChart
        numberCells={3}
        labels={["AC", "WC", "NC"]}
        data={props.data}
        language={props.language}
      />
    </div>
  );
}
export default PieCharts;



// WEBPACK FOOTER //
// ./src/components/Charts/PieChart/PieCharts.js